export let generateSign = (nombre, apellido1) => {
  let firma;
  const generatedLastNames = apellido1.split(" ");
  let generatedLastName = generatedLastNames[0];
  generatedLastName =
    generatedLastName[0].toUpperCase() + generatedLastName.substring(1);
  firma = nombre[0].toUpperCase() + ". " + generatedLastName;
  return firma;
};
